import {currentLanguage, labels} from '../quote-tool/globals/config';

export function menaPrice(price, tax = true) {
    price = parseFloat(price);
    if (price === 0) {
        if (currentLanguage === 'fr') {
            return `${price.toFixed(2)} ${labels.currency}`;
        }

        if (currentLanguage === 'nl') {
            return `${labels.currency} ${price.toFixed(2)}`;
        }
    }

    price = price.toFixed(2);

    if (currentLanguage === 'fr') {
        return `${price} ${labels.currency}`;
    }

    if (currentLanguage === 'nl') {
        return `${labels.currency} ${price}`;
    }
}
